/**
 * What a failed `POST /questions/evaluate` means for the student.
 *
 * The axios interceptor rejects with the RESPONSE (`err.status`, `err.data`),
 * or with `undefined` when no response arrived at all. Before October 2026 the
 * quiz caught none of it: a failed evaluation stopped the spinner and showed
 * nothing, and in a quiz without instant feedback the answer only looked saved.
 *
 *  - `EVALUATION_SERVICE_UNAVAILABLE` (503): WIRIS could not grade the answer.
 *    Nothing was stored; the student can submit again.
 *  - `QUESTION_INSTANCE_INVALID` (409): the question's random numbers are ones
 *    its own algorithm cannot handle, so it can never be graded. The response
 *    carries the same question with new numbers in `new_question_info`.
 */

export const EVALUATION_SERVICE_UNAVAILABLE = 'EVALUATION_SERVICE_UNAVAILABLE'
export const QUESTION_INSTANCE_INVALID = 'QUESTION_INSTANCE_INVALID'

// Evaluate is safe to repeat: the API deletes the question's earlier answer
// before inserting the new one.
export const EVALUATE_RETRY_DELAY_MS = 1000

function errorCode(err) {
    return (err && err.data && err.data.error_code) || ''
}

/** A 5xx, or no response at all, is worth one more try. */
export function isRetryableEvaluateError(err) {
    if (!err) {
        return true
    }
    if (errorCode(err) === QUESTION_INSTANCE_INVALID) {
        return false
    }
    return typeof err.status === 'number' && err.status >= 500
}

/** 'instance_invalid' | 'service_unavailable' | 'other' */
export function evaluateErrorKind(err) {
    const code = errorCode(err)
    if (code === QUESTION_INSTANCE_INVALID) {
        return 'instance_invalid'
    }
    if (code === EVALUATION_SERVICE_UNAVAILABLE) {
        return 'service_unavailable'
    }
    return 'other'
}
